import { getTimelineInterval } from "Areas/SharedFeatures/downSidePanel/redux/selectors";
import documentsSidebarMenuActionCreators from "Areas/Sidebar/Documents/redux/actionCreators";
import { getDocumentsInProgress, getNavigateToId, getObjects, getObjectsInProgress } from "Areas/Sidebar/Documents/redux/selectors";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import { Permissions, security } from "Common/permissions";
import withPopupMessage from "Components/withPopupMessage";
import { connect } from "react-redux";
import documentDetailsActionCreators from "../documentDetails/redux/actionCreators";
import { getFinalReadOnlyMode } from "../documentDetails/redux/getReadOnlyMode";
import { getInnerObjectsSelectedIds } from "../documentDetails/redux/selectors";
import Map from "./map";
import actionCreators from "./redux/actionCreators";
import { getActiveDocumentId, getAllPoints, getCalculatedDetailedPanelOpen, getData, getDetailedPanelData, getInProgress, getMapOptions, getSourceData } from "./redux/selectors";
import { actionCreators as sideBarActionCreators } from "Areas/Sidebar/DocumentsFloat/redux";
import { createNodeSourceCoordinate } from "./utils";
import actionCreatorsDocumentObjectsMap from "../graph/redux/actionCreators.documentObjectsMap";
const canEdit = security.isAllowed([Permissions.DocumentsEdit]);
const mapStateToProps = (state) => ({
    documentId: getActiveDocumentId(state),
    pointsFeatures: getAllPoints(state),
    sourceData: getSourceData(state),
    data: getData(state),
    detailedPanelData: getDetailedPanelData(state),
    inProgress: getInProgress(state) || getObjectsInProgress(state) || getDocumentsInProgress(state),
    documentObjects: getObjects(state),
    navigateToId: getNavigateToId(state),
    selected: getInnerObjectsSelectedIds(state),
    calculatedDetailedPanelOpen: getCalculatedDetailedPanelOpen(state),
    canEdit,
    timelineInterval: getTimelineInterval(state),
    mapOptions: getMapOptions(state),
    readOnlyMode: getFinalReadOnlyMode(state)
});
const mapDispatchToProps = (dispatch) => ({
    onChangeDetailedPanelOpen: open => dispatch(actionCreators.setDetailedPanelOpen(open)),
    onInitialized: () => dispatch(documentsSidebarMenuActionCreators.getObjects()),
    onGetMapData: documentId => dispatch(actionCreators.getDocumentMapData(documentId)),
    onSetMapOptions: (documentId, center, zoom) => dispatch(actionCreators.setMapOptions(documentId, center, zoom)),
    onChangeSelected: (documentId, selected) => dispatch(documentDetailsActionCreators.setInnerObjectsSelectedIds(selected, documentId, DOCUMENT_TYPE.MAP)),
    onAddGeometry: (documentId, data) => {
        dispatch(actionCreators.addGeometry(documentId, data));
        data.Id &&
            dispatch(documentDetailsActionCreators.setInnerObjectsSelectedIds([data.Id], documentId, DOCUMENT_TYPE.MAP));
    },
    onChangeMapData: (documentId, data, nameUpdated, colorUpdated, pointsCoordsUpdated) => dispatch(actionCreators.updateMapData(documentId, data, nameUpdated, colorUpdated, pointsCoordsUpdated)),
    onSaveDocumentMapData: (documentId, prevData, data) => dispatch(actionCreators.saveDocumentMapData(documentId, prevData, data)),
    onGetPreview: (largeAttributeId, completed, rejected) => dispatch(documentDetailsActionCreators.getGraphNodeImageContent(largeAttributeId, completed, rejected)),
    onResetNavigateTo: () => {
        dispatch(documentsSidebarMenuActionCreators.setNavigateTo(undefined));
    },
    onChangeDeleted: ids => {
        dispatch(actionCreators.setDeleted(ids));
    },
    onSendToGraph: (documentId, mapGeometry, documentObjects) => {
        const action = sideBarActionCreators.runMethods(documentId, [
            {
                method: actionCreatorsDocumentObjectsMap.coordinate.methods.addOnGraph,
                nodesSource: [createNodeSourceCoordinate({ mapGeometry, documentObjects })]
            }
        ]);
        if (action) {
            dispatch(action);
        }
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(withPopupMessage(Map));
